<template>
  <div
    class="erroralert alert alert-warning alert-dismissible fade"
    ref="alert"
  >
    <button
      type="button"
      v-on:click="close"
      aria-hidden="true"
      class="close"
    >×</button>
    <span>{{message}}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../store";

export default {
  name: "error-alert",
  data() {
    return {
      message: ""
    };
  },
  computed: {
    ...mapState(["errorMessage"])
  },
  methods: {
    hide() {
      this.jAlert.addClass("fade").removeClass("show");
    },
    show() {
      this.jAlert.addClass("show").removeClass("fade");
    },
    close(ev) {
      ev.preventDefault();
      this.hide();
    }
  },
  mounted() {
    this.jAlert = window.jQuery(this.$refs.alert);
    this.timeoutId = null;
  },
  watch: {
    errorMessage(message) {
      if (!message) return;

      this.message = message;
      store.commit("UNSET_ERROR");
      if (this.timeoutId) {
        console.log(this.timeoutId);

        clearTimeout(this.timeoutId);
      }
      this.show();
      this.timeoutId = setTimeout(() => {
        this.hide();
      }, 2000);
    }
  }
};
</script>

<style scoped>
.erroralert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 233333;
}
.erroralert.fade {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// ErrorAlert.vue?419f49ae